G.LabelTextT = function(str,x,y,textStyle,anchor,maxWidth,distanceBetween){

  Phaser.Group.call(this,game);

  this.str = str;
  this.tagArray = G.LabelParser.changeIntoTagArray(str);

  this.x = x;
  this.y = y;
  this.textStyle = G.Text.getStyle(textStyle);
  this.fontSize = parseInt(textStyle.fontSize);

  this.distanceBetween = distanceBetween || 0;

    if (typeof anchor == 'number') { 
        this.anchorX = this.anchorY = anchor;
    }else {
        this.anchorX = anchor[0];
        this.anchorY = anchor[1];
    }
  

  this.maxWidth = maxWidth || 0;

  this.processTagArray();

};

G.LabelTextT.prototype = Object.create(Phaser.Group.prototype);

G.LabelTextT.prototype.processTagArray = function(){

  for (var i = 0; i < this.tagArray.length; i++) {
    if (this.tagArray[i].type == 'img') {
      var img = G.makeImage(0,0,this.tagArray[i].content,0,this);
      img.tagScale = this.tagArray[i].scale;
    }else if(this.tagArray[i].type == 'separator') {
      var img = G.makeImage(0,0,null,0,this);
      img.SEPARATOR = true;
      img.SEP_LENGTH = this.tagArray[i].length * 0.5;
    }else {
      this.add(new G.Text(0,0,this.tagArray[i].content,this.textStyle))
    }
  }

  this.refresh();

};

G.LabelTextT.prototype.refresh = function(){

  this.applySizeAndAnchor();

  if (this.maxWidth > 0 && this.getWholeWidth() > this.maxWidth) {
    while(this.getWholeWidth() > this.maxWidth) {
      this.distanceBetween = Math.floor(this.distanceBetween*0.9);
      this.fontSize = Math.floor(this.fontSize*0.9);
      this.applySizeAndAnchor();
    }
  }
  
  this.spreadElements();

};


G.LabelTextT.prototype.applySizeAndAnchor = function() {

  this.children.forEach(function(e) {
    e.anchor.setTo(this.anchorX,this.anchorY);
    if (e.fontSize) {
      e.fontSize = this.fontSize;
      e.updateTransform();
      e.y += e.padding.y;
    }else {
      e.height = this.fontSize*(e.tagScale || 1);
      e.scale.x = e.scale.y;
    }

    if (e.SEPARATOR) {
      e.width = this.fontSize*e.SEP_LENGTH;
    }
    
  },this);

};

G.LabelTextT.prototype.getWholeWidth = function() {

  var allDistanceBetween = (this.children.length-1) * this.distanceBetween;
  var widthOfAllElements = 0;
  this.children.forEach(function(e) {
    widthOfAllElements += e.width;
  });
  return allDistanceBetween + widthOfAllElements;

};

G.LabelTextT.prototype.spreadElements = function() {

  var startX = this.getWholeWidth()*this.anchorX*-1;
  this.children.forEach(function(e,index,array) {
    e.left = (index== 0 ? startX : array[index-1].right+this.distanceBetween);
  },this);

};

G.LabelTextT.prototype.addOffsetYToText = function(value) {
  this.children.forEach(function(e) {
    if (e.fontSize) e.y += value;
  })
};